<template>
  <div class="product">
    <!-- 公开课 -->
    <div class="til">
      <div class="title">
        精品课程
        <img src="@/assets/img/partner/corner.png" alt="">
      </div>
      <div @click="saveImg('/partnerPage/courer')">
        查看更多
        <i class="iconfont el-icon-arrow-right" style="font-size: 12px" />
      </div>
    </div>
    <div class="product_content">
      <div class="product_content_imgBox">
        <img src="@/assets/img/partner/product1.png" alt="">
      </div>
      <div @click="goPage(item)" v-for="(item, index) in list" :key="index"
        :class="university != 1 ? 'product_content_item' : 'product_content_item product_content_items'">
        <div class="product_content_item_img">
          <img :src="item.img" alt="">
        </div>
        <div class="product_content_item_title">
          {{ item.title }}
        </div>
        <div class="product_content_item_tips">
          <span v-if="item.types == 5" class="types">面授</span>
          <span v-if="item.types == 2" class="types">录播</span>
          <span v-if="item.types == 1" class="types">直播</span>
          <span class="discipline">{{ item.kindName }}</span>
        </div>
        <div v-if="university != 1" class="product_content_item_price">
          <div class="price">
            <span style="font-size: 16px">￥</span>{{ item.price }}
          </div>
          <el-button class="btn" @click="goPage(item)">去购买</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/common.css'
import { Know } from '@/api/know'
const know = new Know()
import { getInfo } from '@/api/cookies'
import { getDomain } from '@/api/cookies'

export default {
  components: {},
  data() {
    return {
      list: [], // 公开课
      userInfo: null,
      domainInfo: {},
      university: ''
    }
  },
  async created() {
    this.domainInfo = getDomain()
    if (this.domainInfo.eId == process.env.VUE_APP_university) {
      this.university = 1
    }
    this.userInfo = await getInfo()
    this.getList()
  },
  methods: {
    // 项目专业
    async getList() {
      await know.getCourseListnew(6, 1).then((res) => {
        this.list = res.rows
      })
    },
    goPage(item) {
      if (!item) {
        return
      }
      /*  1直播  2 点播  3 音频 4 图文  5 面授  6 课程方向 */
      if (item.types == 1) {
        const routeUrl = this.$router.resolve({
          path: '/zhiboclassxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 2) {
        const routeUrl = this.$router.resolve({
          path: '/videoxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 3) {
        const routeUrl = this.$router.resolve({
          path: '/audioCouser/index',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 4) {
        const routeUrl = this.$router.resolve({
          path: '/imgCouser/index',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 5) {
        const routeUrl = this.$router.resolve({
          path: '/faceCouser/index',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.product {
  margin-top: 138px;
  margin-bottom: 15px;
  width: 1200px;
  margin: 0 auto;
  background-color: #f5f5f5;

  //隐藏滚动条
  ::-webkit-scrollbar {
    display: none !important;
    scrollbar-width: none !important;
    -ms-overflow-style: none;
  }

  /deep/.el-carousel {
    .el-carousel__container {
      display: flex;
    }

    .el-carousel__item {
      width: 100px;
      flex-shrink: 0;
      padding: 0px 32px;
      height: 56px;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      font-size: 18px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 56px;
      // position:data ;
    }
  }

  .til {
    width: 1200px;
    margin: 30px auto 22px;
    height: 42px;
    font-size: 30px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 42px;
    display: flex;
    justify-content: space-between;

    .title {
      position: relative;

      img {
        width: 10px;
        position: absolute;
        right: -8px;
        bottom: 0;
      }
    }

    >div:nth-child(2) {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
    }
  }

  .product_content {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;

    .product_content_imgBox {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      width: 586px;
      height: 300px;
      overflow: hidden;
      margin-right: 26px;

      img {
        width: 107%;
        height: 106%;
      }
    }

    .product_content_item {
      width: 280px;
      height: 300px;
      padding: 10px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      margin-right: 26px;
      margin-top: 24px;
      cursor: pointer;

      &:nth-child(4n-1) {
        margin-right: 0;
      }

      &:nth-child(3) {
        margin-top: 0;
      }

      &:nth-child(2) {
        margin-top: 0;
      }

      .product_content_item_img {
        width: 260px;
        height: 146px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .product_content_item_title {
        width: 260px;
        margin: 10px 0;
        height: 44px;
        line-height: 22px;
        font-size: 14px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
      }

      .product_content_item_tips {
        margin-bottom: 15px;

        .types {
          display: inline-block;
          width: 40px;
          height: 20px;
          background: #ebf4ff;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          padding: 1px 8px;
          margin-right: 10px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #1c81f5;
        }

        .discipline {
          display: inline-block;
          height: 20px;
          background: #f1f2f3;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          padding: 1px 8px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #777a82;
        }
      }

      .product_content_item_price {
        // width: 244px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .price {
          width: 57px;
          height: 25px;
          font-size: 18px;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #fb2d25;
          line-height: 25px;
        }

        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 84px;
          height: 30px;
          background: #ffffff;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          border: 1px solid #1d81f5;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #1d81f5;

          &:hover {
            width: 84px;
            height: 30px;
            background: linear-gradient(180deg, #6cadf8 0%, #1c81f5 100%);
            // box-shadow: 0px 3px 12px 1px rgba(28, 129, 245, 0.34);
            border-radius: 16px 16px 16px 16px;
            opacity: 1;
            color: #ffffff;
            border: 0;
          }
        }
      }
    }

    .product_content_item {
      height: auto;
    }
  }
}
</style>
